(() => {
  'use strict';

  const article = document.querySelector('[data-zv-article]');
  if (!article) return;

  const content = article.querySelector('[data-zv-article-content]');
  const progress = article.querySelector('[data-zv-reading-progress]');

  const updateProgress = () => {
    if (!content || !progress) return;
    const rect = content.getBoundingClientRect();
    const contentTop = window.scrollY + rect.top;
    const contentHeight = content.offsetHeight;
    const viewport = window.innerHeight;
    const travelled = window.scrollY + viewport * 0.25 - contentTop;
    const total = Math.max(contentHeight - viewport * 0.4, 1);
    const percentage = Math.min(100, Math.max(0, (travelled / total) * 100));
    progress.style.width = `${percentage}%`;
  };

  let ticking = false;
  const requestProgressUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      updateProgress();
      ticking = false;
    });
  };

  window.addEventListener('scroll', requestProgressUpdate, { passive: true });
  window.addEventListener('resize', requestProgressUpdate);
  updateProgress();

  if (content) {
    const headings = Array.from(content.querySelectorAll('h2, h3'));
    const tocContainers = Array.from(article.querySelectorAll('[data-zv-toc]'));
    const tocCard = article.querySelector('[data-zv-toc-card]');
    const tocMobile = article.querySelector('[data-zv-toc-mobile]');

    const slugify = (value) => value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 72);

    if (headings.length >= 2 && tocContainers.length) {
      const usedIds = new Set();

      headings.forEach((heading, index) => {
        let id = heading.id || slugify(heading.textContent.trim()) || `onderdeel-${index + 1}`;
        const baseId = id;
        let suffix = 2;
        while (usedIds.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
          id = `${baseId}-${suffix}`;
          suffix += 1;
        }
        heading.id = id;
        usedIds.add(id);
      });

      tocContainers.forEach((container) => {
        const fragment = document.createDocumentFragment();
        headings.forEach((heading) => {
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          link.dataset.level = heading.tagName === 'H3' ? '3' : '2';
          link.addEventListener('click', () => {
            const details = link.closest('details');
            if (details) details.open = false;
          });
          fragment.appendChild(link);
        });
        container.appendChild(fragment);
      });

      if (tocCard) tocCard.hidden = false;
      if (tocMobile) tocMobile.hidden = false;

      const tocLinks = Array.from(article.querySelectorAll('[data-zv-toc] a'));
      const setActive = (id) => {
        tocLinks.forEach((link) => {
          const active = link.getAttribute('href') === `#${id}`;
          link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (visible[0]) setActive(visible[0].target.id);
        }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 });
        headings.forEach((heading) => observer.observe(heading));
      }
    }
  }

  const copyButton = article.querySelector('[data-zv-copy-link]');
  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const label = copyButton.querySelector('span');
      const original = label ? label.textContent : '';
      try {
        await navigator.clipboard.writeText(window.location.href);
        if (label) label.textContent = copyButton.dataset.copiedLabel || 'Link gekopieerd';
      } catch (error) {
        const temporary = document.createElement('textarea');
        temporary.value = window.location.href;
        temporary.setAttribute('readonly', '');
        temporary.style.position = 'fixed';
        temporary.style.opacity = '0';
        document.body.appendChild(temporary);
        temporary.select();
        document.execCommand('copy');
        temporary.remove();
        if (label) label.textContent = copyButton.dataset.copiedLabel || 'Link gekopieerd';
      }
      window.setTimeout(() => {
        if (label) label.textContent = original;
      }, 2200);
    });
  }

  const shareButton = article.querySelector('[data-zv-share-article]');
  if (shareButton) {
    shareButton.addEventListener('click', async () => {
      if (navigator.share) {
        try {
          await navigator.share({
            title: document.title,
            text: document.querySelector('meta[name="description"]')?.content || '',
            url: window.location.href
          });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }
      if (copyButton) copyButton.click();
    });
  }
})();
